module.exports = __webpack_public_path__ + "static/media/disc_active1.e1c3bf66.png";